import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { AuthProvider } from './providers/Authentication';
import StaticProvider from './providers/StaticProvider';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AppRoutes } from './config/routes';
import { ConfigProvider } from 'antd';

function App() {
  const routers = createBrowserRouter(AppRoutes);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider>
          <StaticProvider>
            <ConfigProvider>
              <RouterProvider router={routers}></RouterProvider>
            </ConfigProvider>
          </StaticProvider>
        </AuthProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
